import auth from './auth';
import comment from './comment';
import common from './common';
import epPanel from './epPanel';
import main from './main';
import notice from './notice';
import videos from './videos';
import boards from './boards';
import media from './media';
import event from './event';
import faq from './faq';
import qna from './qna';
import recommends from './recommends';
import story from './story';
import myPage from './myPage';
import mobile from './mobile';
import search from './search';
import celebration from './celebration';
import topEatsBoards from './topEatsBoards';
import tempBoards from './tempBoards';
import popupInfo from './popupInfo';
import mentionsBoards from './mentionsBoards';
import executiveAppointment from './executiveAppointment';
import departmentBoards from './departmentBoards';
import societyBoards from './societyBoards';
import announcementBoards from './announcementBoards';
import shortsMedia from './shorts';
import withdrawal from './withdrawal';
import bookstoreBoards from "./bookstoreBoards";
import exaoneChatbot from './exaoneChatbot';

export default {
  auth,
  comment,
  common,
  popupInfo,
  epPanel,
  main,
  notice,
  videos,
  /** 자유 게시판 */
  boards,
  /** 맛집 게시판 */
  topEatsBoards,
  // 고객 요청 사항으로 게시판명만 '<체력의 신> 챌린지' 으로 변경한 채 오픈 (2025. 08. 26)
  /** '<체력의 신> 챌린지' 게시판 */
  mentionsBoards,
  /** 직무 게시판 */
  departmentBoards,
  /** 소모임 게시판 */
  societyBoards,
  /** 공지 게시판 */
  announcementBoards,
  /** 게시판 임시 저장 */
  tempBoards,
  media,
  event,
  faq,
  qna,
  recommends,
  story,
  myPage,
  mobile,
  search,
  celebration,
  executiveAppointment,
  /** 숏폼 미디어 */
  shortsMedia,
  /** 회원 탈퇴 */
  withdrawal,
  /** 독서 챌린지 게시판 */
  bookstoreBoards,
  /** EXAONE 챗봇 */
  exaoneChatbot,
};
